








































import { Component, Vue } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { EditorialProject } from '@/models'
import { MutationTypes } from '@/store/mutation-types'

@Component({
  components: {
    FavoriteCourses: () => import('@/components/FavoriteCourses.vue')
  }
})
export default class Home extends Vue {
  private projects: Array<EditorialProject> = []
  private fallbackImage = `${process.env.BASE_URL}img/placeholder-project.svg`

  // Si la imagen del proyecto no carga (URL vacía o 404), mostramos el logo genérico.
  // Evitamos un bucle infinito comprobando que no estemos ya en el fallback.
  private onImageError(event: Event) {
    const img = event.target as HTMLImageElement
    if (!img.src.endsWith(this.fallbackImage)) {
      img.src = this.fallbackImage
    }
  }

  created() {
    ApiClient.getEditorialProjects()
      .then(projects => {
        this.projects = projects
      })
      .catch(err => {
        console.error('Error getProjects: ' + err)
      })

    this.$store.commit(MutationTypes.SET_ACTIVE_PROJECT, {})
    this.$store.commit(MutationTypes.SET_ACTIVE_PRODUCT, {})
    window.document.title = `${this.$i18n.t('pageTitle.home')} - LDX`
  }
}
